import update from "immutability-helper";
import {ChatActions} from "../actions/Chat";

export const initialState = () => {
  return {
    sub: false,
    channel: null,
    errors: null,
    messages: {},
    peers: {},
    statuses: {},
    lastStatusAt: 0, // Timestamp
    peerProfile: null,
    finished: false,
    push: false,
    review: false,
    videoChat: false,
    videoChatUrl: null,
  }
}

const chat = (state = initialState(), action) => {
  switch (action.type) {
    case ChatActions.SET_ATTRIBUTE:
      return update(state, { [action.key]: { $set: action.value } });
    case ChatActions.ADD_MESSAGE:
      return update(state, {
        messages: { // autivivification trick
          [action.value.chatStorageKey] :
            chat => update(chat || [], { $push: [{ source: action.key, message: action.value.message }] })
        } });
    case ChatActions.SET_PEER:
      return update( state,
        { peers: { [action.key]: { $set: action.value } } });
    case ChatActions.SET_STATUS:
      return update( state,
        { statuses: { [action.key]: { $set: action.value } } });
    case ChatActions.RESET_STATE:
      return update(state, {$set: initialState()})
    default:
      return state;
  }
};

export default chat;
